import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { FilterBar } from '@/components/ui/data-table-customized'
import { useAssetList } from '@/modules/Asset/hooks/use-asset-list'

const MyAssets = () => {
    const {
        assets,
        pagination,
        stateComponent,
        control,
        setFilter,
        params,
        searchInputProps,
        columns,
        actions,
        filterItems,
        filterToggles,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useAssetList('my')

    return (
        <Paper className="space-y-2">
            <FilterBar
                storageKey="assets-my"
                control={control}
                setFilter={setFilter}
                items={filterItems}
            />

            {stateComponent || (
                <DataTableCustomized
                    columns={columns}
                    rows={assets}
                    rowKey={(row) => row.asset_slug}
                    actions={actions}
                    size="small"
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('filters.search'),
                        },
                        settings: {
                            show: true,
                            storageKey: 'assets-my',
                            filterToggles,
                        },
                    }}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                    pagination={{
                        page: params.page,
                        pageSize: params.page_size,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                    }}
                />
            )}
        </Paper>
    )
}

export default MyAssets
